import { AppConst } from 'src/app/shared/constants/app-const';
import { NoiseLatestSiteData } from 'src/app/shared/interfaces/latest-site-data';
import { SensorHistory } from 'src/app/shared/interfaces/sensor-history';

import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AreaChartComponent, LegendPosition } from '@swimlane/ngx-charts';

import {
  LineChartResultDto,
  LineChartResultSeriesDto,
} from '../../charts.interface';
import { ChartsService } from '../../charts.service';

@Component({
  selector: 'app-noise-line-chart',
  templateUrl: './noise-line-chart.component.html',
  styleUrls: ['./noise-line-chart.component.scss'],
})
export class NoiseLineChartComponent implements OnChanges {
  @Input() data: NoiseLatestSiteData = {} as NoiseLatestSiteData;
  @Input() chartRange: string = 'daytime';
  @ViewChild(AreaChartComponent) chart: AreaChartComponent | null = null;

  results: LineChartResultDto[] = [];

  // Line chart options
  view: [number, number] = [600, 400];
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = false;
  legendTitle = '騒音 (dB)';
  legendPosition = LegendPosition.Below;
  showXAxisLabel = false;
  xAxisLabel = 'Year';
  showYAxisLabel = false;
  yAxisLabel = 'Population';
  yScaleMin = 0;
  yScaleMax = AppConst.NOISE_LINE_CHART_Y_SCALE_MAX;

  colorScheme = 'cool';
  lineColor = '#9C27B0';
  customColors = (value: string) => {
    return this.lineColor;
  };

  timeline = true;

  sensorId = '';
  dataList: LineChartResultSeriesDto[] = [];

  constructor(private chartsService: ChartsService) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.sensorId = this.data.id;
    this.setChartWidth();

    const histories = await this.getHistories();
    this.clearAllData();
    this.createDataSets(histories);

    // 表示対象風速データの最大値が10を超えていたら、グラフの縦軸もそれに合わせる
    const noiseL5 = this.getNoiseL5(histories);
    if (noiseL5 > AppConst.NOISE_LINE_CHART_Y_SCALE_MAX) {
      this.yScaleMax = noiseL5;
    }

    // console.log(this.wbgtDataList.length);

    this.results = [];
    this.results.push({
      name: '騒音',
      series: this.dataList,
    });

    if (this.chart) {
      this.chart.update();
    }
  }

  onResize(event: UIEvent) {
    this.setChartWidth();
  }

  setChartWidth() {
    this.view[0] = this.chartsService.getChartWidthFromWindowWidth(
      window.innerWidth
    );
  }

  onSelect(event: any) {}

  async getHistories() {
    let histories: SensorHistory[] | null = null;
    if (this.chartRange === '' || this.chartRange === 'daytime') {
      histories = await this.chartsService.getDaytimeSensorHistory(
        this.sensorId
      );
    } else if (this.chartRange === 'day') {
      histories = await this.chartsService.getDaySensorHistory(this.sensorId);
    } else if (this.chartRange === 'week') {
      histories = await this.chartsService.getWeekSensorHistory(this.sensorId);
    } else if (this.chartRange === 'month') {
      histories = await this.chartsService.getMonthSensorHistory(this.sensorId);
    }

    return histories;
  }

  getNoiseL5(histories: SensorHistory[] | null) {
    if (histories === null) return 0;

    const noiseArray: number[] = [];
    for (let history of histories) {
      if (history === undefined) continue;

      if (history.noiseL5 !== undefined) {
        noiseArray.push(history.noiseL5);
      }
    }

    return Math.max.apply(null, noiseArray);
  }

  createDataSets(histories: SensorHistory[] | null) {
    if (histories === null) return;

    const result = this.chartsService.createNoiseChartDataSets(
      this.chartRange,
      histories
    );
    if (result !== undefined) {
      this.dataList = result.noise;
    }
  }

  clearAllData() {
    this.dataList = [];
  }
}
